
















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class RiwayatPenyakit extends Vue {
  @Prop() setRiwayatPenyakit: string;
  @Prop() setLabel!: string;
  riwayatPenyakit = null;
  label = "";
  placeholder = this.setLabel;
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  //   get riwayatPenyakit() {
  //     return this.setRiwayatPenyakit;
  //   }
  //   set riwayatPenyakit(value) {
  //     this.$emit("riwayatPenyakit", value);
  //   }
  @Watch("riwayatPenyakit")
  changeRiwayat(v) {
    if (v == "") {
      this.label = "";
      this.placeholder = this.setLabel;
    } else {
      this.label = this.setLabel;
      this.placeholder = this.setLabel;
    }
    this.$emit("riwayatPenyakit", v);
  }
  @Watch("setRiwayatPenyakit")
  changesetRiwayat(v) {
    this.riwayatPenyakit = v;
  }
}
